<template>
  <div class="vx-row">
    <div
      class="vx-col"
      style="margin: auto; padding-bottom: 50px; padding-top: 50px"
    >
      <transition name="fade">
        <Card>
          <div
            class="py-3"
            style="text-align: center; padding-left: 75px; padding-right: 75px"
          >
            <img
              src="@/assets/images/logo/kontur_logo.svg"
              alt="logo"
              class="sidebar__logo"
            />
            <p style="font-weight: 500; margin-bottom: 0px">
              Создание организации
            </p>
          </div>
          <form @submit.prevent>
            <div class="py-3">
              <vs-input
                label="Название организации"
                v-model="name"
                name="name"
                v-validate="'required'"
                :danger="errors.has('name')"
                :danger-text="errors.first('name')"
              />
              <vs-input
                v-validate="'required|numeric'"
                data-vv-validate-on="blur"
                name="inn"
                label="ИНН"
                v-model="inn"
                :danger="errors.has('inn')"
                :danger-text="errors.first('inn')"
              />
              <vs-input
                label="Имя контактного лица"
                v-model="first_name"
                name="first_name"
                v-validate="'required'"
                :danger="errors.has('first_name')"
                :danger-text="errors.first('first_name')"
              />
              <InputPhone v-model="phone" />
              <div class="mt-6">
                <vs-button
                  button="submit"
                  style="margin: auto; display: block"
                  @click="updateBranch"
                  :disabled="!validateForm"
                  >Сохранить</vs-button
                >
              </div>
            </div>
          </form>
        </Card>
      </transition>
    </div>
  </div>
</template>
<script>
import { REGISTER_COMPANY } from '@/store/action.types'
import { loadSupportCenter } from '@skbkontur/support-center'
import { TP_WIDGET_URL } from '../../../common/config.js'
let supportCenter

export default {
  data() {
    return {
      first_name: '',
      inn: '',
      phone: '',
      name: ''
    }
  },
  computed: {
    validateForm() {
      return (
        !this.errors.any() &&
        this.first_name !== '' &&
        this.inn !== '' &&
        this.phone !== '' &&
        this.name !== ''
      )
    }
  },
  methods: {
    async initSupportCenterWidget() {
      const { SupportCenterConstructor, error } = await loadSupportCenter(
        TP_WIDGET_URL
      )

      if (!SupportCenterConstructor) {
        error('Не удалось скачать виджет')
      }

      const envSupportCenterWidget =
        process.env.VUE_APP_ENV === 'production' ? 'production' : 'staging'

      const parameters = {
        integrationId: 'tips', // KE-web, cabinet, diadoc и др.
        type: 'dom',
        environment: envSupportCenterWidget, // staging - стабильная тестовая площадка, production - боевая
        additionalParameters: {
          'base/inn': this.currentUser.inn,
          'base/login': this.currentUser.username
        }
      }

      supportCenter = new SupportCenterConstructor(parameters)

      const response = await supportCenter.initialize()
      if (response.code !== 'ok') {
        error(response.context.message)
      }
    },
    updateBranch() {
      this.$validator.validateAll().then((result) => {
        if (result) {
          this.$vs.loading()
          const payload = {
            registration_token: this.$route.query.registration_token,
            first_name: this.first_name,
            inn: this.inn,
            phone_number: this.phone,
            name: this.name,
            address: this.address,
            payments_strategy: this.payments_strategy
          }
          this.$store
            .dispatch(REGISTER_COMPANY, payload)
            .then(() => {
              this.$vs.loading.close()
              this.$router.push({
                name: 'pageLogin',
                query: { access_token: this.$route.query.access_token }
              })
            })
            .catch(({ response }) => {
              this.$vs.loading.close()
              this.$vs.notify({
                title: 'Не удалось зарегистрироваться',
                text: response.data.error
              })
              if (supportCenter) {
                setTimeout(() => supportCenter.openWithModule('chat'), 3000)
              }
            })
        }
      })
    }
  },
  mounted() {
    this.initSupportCenterWidget()
  }
}
</script>
<style lang="scss" scoped></style>
